export const aclRolesMap = {
  DATA_ADMIN: 'data-admin',
  EDITOR: 'editor',
  VIEWER: 'viewer',
};
